import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Select from 'react-select'
import CustomSelect from '../Utilities/CustomSelect';
import { ClientSubscribeVM } from '../../Structure/ViewModels/Accountant/ClientSubscribeVM';
import { mainPath } from '../../Structure/Constants/MainPath';
import CustomImageUpload from '../Utilities/CustomImageUpload';

const ClientSubscribe = (props:{id:string, name:string}) => {
  const [vm,setVm] = useState<{viewModel:ClientSubscribeVM}>({viewModel: new ClientSubscribeVM(props.id,props.name)})
  const control = vm.viewModel
  useEffect(()=>{ control.subscribeUpdate(setVm); }, [])
  
  return (
    <Container>
      <Row className='py-5'>
        <h3 className='fw-bold text-center txt-color-I'>اضافة اشتراك</h3>
      </Row>
      <Row className='pb-5'>
      <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
        <Row  className='w-100'>
          <Col md={12} className='d-flex justify-content-around'>
            <label className='my-auto py-2 py-md-0'>الاسم</label>
            <label className='my-auto py-2 py-md-0 txt-color-I fw-bold'>{control.Data.name}</label>
          </Col>
        </Row>
      </Col>
      <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
        <Row  className='w-100'>
          <Col md={12} className='d-flex justify-content-around'>
            <label className='my-auto py-2 py-md-0'>السعر</label>
            <label className='my-auto py-2 py-md-0 txt-color-I fw-bold'>{control.Price}</label>
          </Col>
        </Row>
      </Col>
      </Row>
      <Row className='pb-5'>
      <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
        <Row  className='w-100'>
          <Col md={12} className='d-flex justify-content-around'>
            <label className='my-auto py-2 py-md-0'>سعر العملة</label>
            <label className='my-auto py-2 py-md-0 txt-color-I fw-bold'>{control.CurrencyPrice}</label>
          </Col>
        </Row>
      </Col>
      <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
        <Row  className='w-100'>
          <Col md={12} className='d-flex justify-content-around'>
            <label className='my-auto py-2 py-md-0'>السعر المحلى</label>
            <label className='my-auto py-2 py-md-0 txt-color-I fw-bold'>
              {
                control.LocalPrice
              }
            </label>
          </Col>
        </Row>
      </Col>
      </Row>
      <Row className='border p-3'>
        <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
          <Row  className='w-100'>
            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
              <label htmlFor="marketier" className='my-auto py-2 py-md-0'>التخصص</label>
            </Col>
            <Col md={8}>
              <CustomSelect list={control.LevelSpecializations} selected={control.Data.levelSpecializations_id} onSelect={a=>control.Specialization = a} />
            </Col>
          </Row>
        </Col>
        <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
          <Row  className='w-100'>
            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
              <label htmlFor="marketier" className='my-auto py-2 py-md-0'>نوع الحساب</label>
            </Col>
            <Col md={8}>
              <CustomSelect list={control.Accounts} selected={control.Data.account_id} onSelect={a=>control.Account=a} />
            </Col>
          </Row>
        </Col>
        <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
          <Row  className='w-100'>
            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
              <label htmlFor="marketier" className='my-auto py-2 py-md-0'>التوثيق</label>
            </Col>
            <Col md={8}>
              <CustomSelect list={[{label:'توثيق', value:'verify'} , {label:'بدون توثيق' , value:'no verify'}]} selected={control.Data.verification} onSelect={a=>control.Verification=a} />
            </Col>
          </Row>
        </Col>
        <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
          <Row className='w-100'>
            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
              <label htmlFor="purchased" className='my-auto py-2 py-md-0'>خصم </label>
            </Col>
            <Col md={8}>
              <input id='purchased' type="text" className='w-100 input-field' value={control.Data.discount} onChange={a=>control.Discount=a.target.value} placeholder='خصم...' />
            </Col>
          </Row>
        </Col>
        <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
          <Row className='w-100'>
            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
              <label htmlFor="remained" className='my-auto py-2 py-md-0'>المدفوع</label>
            </Col>
            <Col md={8}>
              <input id='remained' type="text" className='w-100 input-field' value={control.Data.paid} onChange={a=>control.Paid=a.target.value} placeholder='المدفوع...' />
            </Col>
          </Row>
        </Col>
        <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
          <Row className='w-100'>
            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
              <label htmlFor="remained" className='my-auto py-2 py-md-0'>مبلغ اضافى</label>
            </Col>
            <Col md={8}>
              <input type="text" className='w-100 input-field' value={control.Data.additional} onChange={(a)=>control.Additional=a.target.value} placeholder='مبلغ اضافى...' />
            </Col>
          </Row>
        </Col>
        <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
          <Row className='w-100 h-100 d-flex my-auto'>
            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
              <label htmlFor="remained" className='my-auto py-2 py-md-0'>تاريخ التحويل</label>
            </Col>
            <Col className='d-flex my-auto' md={8}>
              <input id='remained' type="date" className='w-100 input-field text-center my-auto' onChange={a=>control.TransferDate=a.target.value} />
            </Col>
          </Row>
        </Col>
        <Col lg={6} className='d-flex flex-column justify-content-center px-3 py-3'>
          <Row className=' d-flex w-100 my-auto'>
            <Col md={4} className='justify-content-center justify-content-md-start my-auto'>
              <label htmlFor="remained" className='my-auto py-2 py-md-0'>صورة الايصال</label>
            </Col>
            <Col className='my-auto' md={8}>
              <CustomImageUpload clear={a=>control.ClearImg=a} onSelect={a=>control.Img=a}/>
            </Col>
          </Row>
        </Col>
        <Col lg={6} className='d-flex justify-content-between px-3 py-3 pt-5'>
          <Row className='w-100'>
            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
              <label htmlFor="remained" className='my-auto py-2 py-md-0 '>ملاحظات</label>
            </Col>
            <Col md={8}>
              <textarea 
                placeholder='ملاحظات'
                onChange={a=>control.Notes = a.target.value} className="input-field w-100 "
                style={{height:'100%', resize:'none'}} 
              />
            </Col>
          </Row>
        </Col>
        <Row className=' justify-content-center pt-3'>
          <Col lg={12} className='d-flex justify-content-center px-3 py-3 pt-5'>
              <button className='button-I btn-cl-I mx-3 p-1 px-5 fs-5 ' onClick={()=>control.send()}>تسجيل</button>
          </Col>
        </Row>
      </Row>
    </Container>
  )
}

export default ClientSubscribe
